/** Preserve removal batches when individual cards are retrieved; repair older flat saves. */
export const reserveGroupsOf = (ids: string[], saved?: unknown): string[][] => {
  const available = new Set(ids), used = new Set<string>();
  const groups: string[][] = [];
  if (Array.isArray(saved)) for (const value of saved) {
    if (!Array.isArray(value)) continue;
    const group: string[] = [];
    for (const id of value) if (typeof id === 'string' && available.has(id) && !used.has(id)) {
      used.add(id); group.push(id);
    }
    for (let i = 0; i < group.length; i += 3) groups.push(group.slice(i, i + 3));
  }
  const remaining = ids.filter(id => !used.has(id));
  for (let i = 0; i < remaining.length; i += 3) groups.push(remaining.slice(i, i + 3));
  return groups;
};

/** Keep each removal batch in three fixed columns, including holes after retrieval. */
export const reserveColumnsOf = (ids: string[], groups?: unknown, saved?: unknown): Record<string, number> => {
  const stored = saved && typeof saved === 'object' ? saved as Record<string, unknown> : {};
  const columns: Record<string, number> = {};
  for (const group of reserveGroupsOf(ids, groups)) {
    const used = new Set<number>();
    for (const id of group) {
      const column = stored[id];
      if (typeof column === 'number' && Number.isInteger(column) && column >= 0 && column < 3 && !used.has(column)) {
        columns[id] = column; used.add(column);
      }
    }
    for (const id of group) if (columns[id] === undefined) {
      const column = [0, 1, 2].find(value => !used.has(value))!;
      columns[id] = column; used.add(column);
    }
  }
  return columns;
};
export const reserveStacksOf = (ids: string[], groups?: unknown, saved?: unknown): string[][] => {
  const columns = reserveColumnsOf(ids, groups, saved), stacks: string[][] = [[], [], []];
  for (const group of reserveGroupsOf(ids, groups)) for (const id of group) stacks[columns[id]].push(id);
  return stacks;
};
